export default __webpack_public_path__ + "static/media/new_delvLogo.1e1219dc.png";